import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

// Components
import { Button, Text, Link } from '@beef/ui-kit';
import { ArrowButton } from 'components';

// Styles
import styles from './styles.pcss';

const cn = classNames.bind(styles);

const ResultPopup = ({
  title,
  imageUrl,
  arrowText,
  description,
  onReturnBackBtnClick,
  children,
  hasButtons,
  onClick,
  buttonText,
  buttonUrl,
  inProgress,
}) => (
  <div className={cn('error')}>
    {arrowText && onReturnBackBtnClick && (
      <div className={cn('error__arrow')}>
        <ArrowButton text={arrowText} onClick={onReturnBackBtnClick} />
      </div>
    )}
    {imageUrl && (
      <div className={cn('error__icon-wrapper')}>
        <img className={cn('error__icon')} src={imageUrl} alt="ошибка" />
      </div>
    )}
    {title && (
      <div className={cn('error__title')}>
        <Text
          color="grey95"
          size="size2-m"
        >
          {title}
        </Text>
      </div>
    )}
    {description && (
      <div className={cn('error__description')}>
        <Text
          color="grey50"
          size="size5-r-s"
        >
          {description}
        </Text>
      </div>
    )}
    {hasButtons && (
      <div className={cn('error__group')}>
        {onClick && !buttonUrl && (
        <Button
          variant="secondary"
          size="m"
          fullWidth
          onClick={onClick}
          isLoading={inProgress}
        >
          {buttonText}
        </Button>
        )}
        {buttonUrl && (
        <Link
          href={buttonUrl}
          buttonSize="m"
          variant="button"
          buttonVariant="secondary"
          isFullWidth
          isLoading={inProgress}
        >
          {buttonText}
        </Link>
        )}
        {children}
      </div>
    )}
  </div>
);

ResultPopup.propTypes = {
  title: PropTypes.string,
  imageUrl: PropTypes.string,
  arrowText: PropTypes.string,
  description: PropTypes.string,
  onReturnBackBtnClick: PropTypes.func,
  hasButtons: PropTypes.bool,
  onClick: PropTypes.func,
  buttonText: PropTypes.string,
  buttonUrl: PropTypes.string,
  inProgress: PropTypes.bool,
};
export { ResultPopup };
